/**
 * created by wang lei
 * 通知公告 页面
 */
import React from 'react';
import {Avatar, Button, Icon, message, Modal, Pagination, Radio, Tabs, Upload} from "antd";
import moment from "moment";
import AddingNotices from "./addingNotices";
import {Scrollbars} from "react-custom-scrollbars";
import {filterXSS, uuid} from "../../../utils";
import UploadWall from "../../../components/upload/UploadWall";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {getInfoFromLocalStorage} from "../../../actions";
import {HEADER_HEIGHT} from "../../../constants";
import  {getColorByState} from "../../components/colorByState/colorByState";

import user from "../img/user.png"

const {confirm} = Modal;
const {TabPane} = Tabs;


export default class Notice extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state={
            visible: false,
            pageSize:10,
            pageNum:1,
            page:1,
            total:"1",
            modalKey:uuid(),
            storageFileList:[],
            readMedal:false,
            current:'已读',
            noticeId:'',
            readStatus:1,
            readList:[],
            readNum:0,//通知总人数
            readTotal:0,//已读个数
            columns: [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    width: 350,
                    ellipsis: true,
                    render:(text,record)=>{
                        return <div style={{overflow: 'hidden',textOverflow:'ellipsis',cursor:'pointer'}} onClick={() => {
                            this.state.record=record;
                            this.state.storageFileList = []
                            this.getNotice((notice)=>{
                                this.getStorageFileListByUrls(notice.attachements,()=>{
                                    if(record.status === 3 ){
                                        this.updateViewStatus(record.id)
                                    }
                                    this.showModal(record.status)
                                })
                            });
                        }}>
                            {record.title}
                        </div>
                    }
                },
                {
                    title: '发送者',
                    dataIndex: 'codeName',
                    key: 'codeName',
                    width: 150,
                    ellipsis: true,
                    render: (text,record) => {
                        return (
                            <span title={record.senderName}>{record.senderName && record.senderName.length>10?record.senderName.substring(0,10)+"...":record.senderName}</span>
                        )
                    }
                },
                {
                    title: '发布时间',
                    dataIndex: 'dbUpdateTime',
                    key: 'dbUpdateTime',
                    width: 150,
                    ellipsis: true,
                    render: (text,record) => {
                        return (
                            <div>
                                {record.status==3? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </div>
                        )
                    }
                },
                {
                    title:'已读',
                    dataIndex:'read',
                    key:'read',
                    width:150,
                    render:(text,record)=>{
                        if(record.readTotal!==record.total&&record.status===3){
                            return(
                                <div>
                                    <div><span style={{color: '#0050b3', cursor: "pointer"}} onClick={() => {
                                        this.setState({
                                            readMedal: true,
                                            noticeId: record.id,
                                            readTotal: record.readTotal,
                                            readNum: record.total,
                                            current:'已读',
                                            readStatus:1
                                        }, () => {
                                            this.getReadList()
                                        })
                                    }}>{record.readTotal}</span>/{record.total}</div>
                                </div>
                            )
                        }else if(record.status!==3){
                            return('')
                        }else if(record.readTotal===record.total){
                            return(
                                <div>{'全部已读'}</div>
                            )
                        }

                    }

                },
                {
                    title: '状态',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width: 120,
                    ellipsis: true,
                    render: (text,record) => {
                        return this.formatState(record.status)
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'wordsNum',
                    key: 'wordsNum',
                    width: 180,
                    ellipsis: true,
                    render: (text,record) => {
                        let that = this;
                        let isMain=window.currentUser&&(window.currentUser.id==record.sender);
                        switch (record.status){
                            case 0:
                                return (
                                    <div style={{cursor: "pointer",color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>
                                        <span style={{marginRight: 15}}
                                              onClick={() => {
                                                  this.state.record=record;
                                                  this.state.storageFileList = []
                                                  this.getNotice((notice)=>{
                                                      this.getStorageFileListByUrls(notice.attachements,()=>{
                                                          this.showModal()
                                                      })
                                                  });
                                              }}>查看</span>
                                        <span style={{marginRight: 15, display: isMain ? '' : 'none'}} onClick={() => {
                                            this.state.record = record;
                                            this.getNotice((noticeData)=>{
                                                this.getStorageFileListByUrls(noticeData.attachements,(storageFileList)=>{
                                                    this.addingNotices.showModal(record, storageFileList,noticeData)
                                                })
                                            })
                                        }}>编辑
                                        </span>
                                        <AddingNotices ref={e=>this.addingNotices=e} key={this.state.modalKey} onCloseCall={()=>{this.setState({modalKey:uuid()})}} record={record} getList={this.getList}/>
                                        <span style={{display: isMain ? '' : 'none'}} onClick={() => {
                                            if (!(record && record.id)) {
                                                message.error("数据id丢失")
                                            }
                                            confirm({
                                                title: '确定要删除吗？',
                                                onOk() {
                                                    that.getUpdateStatus({
                                                        params: {
                                                            noticeId: record.id,
                                                            status: 1,
                                                        },
                                                        statusNameTemp: "删除"
                                                    })
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            })
                                        }}>删除</span>
                                    </div>
                                )
                            case 3:
                                return (
                                    <div style={{cursor: "pointer",color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>
                                        <span style={{marginRight: 15}}
                                              onClick={() => {
                                                  this.state.record=record;
                                                  this.state.storageFileList = []
                                                  this.getNotice((notice)=>{
                                                      this.getStorageFileListByUrls(notice.attachements,()=>{
                                                          this.updateViewStatus(record.id)
                                                          this.showModal(record.status)
                                                      })
                                                  });
                                              }}>查看</span>
                                        <span style={{display: isMain ? '' : 'none'}} onClick={() => {
                                            if (!(record && record.id)) {
                                                message.error("数据id丢失")
                                            }
                                            confirm({
                                                title: '确定要撤回吗？',
                                                onOk() {
                                                    that.getUpdateStatus({
                                                        params: {
                                                            noticeId: record.id,
                                                            status: 2,
                                                        },
                                                        statusNameTemp: "撤回"
                                                    })
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            })
                                        }}>撤回</span>
                                    </div>
                                )
                            case 2:
                                return (
                                    <div style={{cursor: "pointer",color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>
                                        <span style={{marginRight: 15}}
                                              onClick={() => {
                                                  this.state.record=record;
                                                  this.state.storageFileList = []
                                                  this.getNotice((notice)=>{
                                                      this.getStorageFileListByUrls(notice.attachements,()=>{
                                                          this.showModal()
                                                      })
                                                  });
                                              }}>查看</span>
                                        <span style={{marginRight: 15, display: isMain ? '' : 'none'}} onClick={() => {
                                            this.state.record = record;
                                            this.getNotice((noticeData)=>{
                                                this.getStorageFileListByUrls(noticeData.attachements,(storageFileList)=>{
                                                    this.addingNotices.showModal(record, storageFileList,noticeData)
                                                })
                                            })
                                        }}>编辑
                                        </span>
                                        <AddingNotices ref={e=>this.addingNotices=e} key={this.state.modalKey} onCloseCall={()=>{this.setState({modalKey:uuid()})}} getList={this.getList}/>
                                        <span style={{display: isMain ? '' : 'none'}} onClick={() => {
                                            if (!(record && record.id)) {
                                                message.error("数据id丢失")
                                            }
                                            confirm({
                                                title: '确定要删除吗？',
                                                onOk() {
                                                    that.getUpdateStatus({
                                                        params: {
                                                            noticeId: record.id,
                                                            status: 1,
                                                        },
                                                        statusNameTemp: "删除"
                                                    })
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            })
                                        }}>删除</span>
                                    </div>
                                )
                        }
                    }
                }
            ],
            dataList: [],
            stateCountByState: {
                0 : "草稿",  
                2 : "撤回",
                3 : "已发布",
            }
        }
    }

    /**
     * 控制状态渲染
     */
    formatState = (status) => {
        const { stateCountByState } = this.state;
        const stateText = stateCountByState[status];
        const color = getColorByState(stateText);
            return (
                <div className='dotState'>
                    <div style={{background: color}}></div>
                    {stateText || "-"}
                </div>
            )
    }

    componentDidMount() {
        this.getList()
    }

    showModal = (status) => {
        this.setState({
            visible: true,
            status
        });
    };
    handleOk = e => {
        this.setState({
            visible: false,
            readMedal:false,
        });
    };

    handleCancel = e => {
        if(this.state.status === 3){
            this.getList()

        }
        this.setState({
            visible: false,
            readMedal:false,
        });
    };

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT -30-30-25-35-24-60 ;
        let currentUser=getInfoFromLocalStorage("currentUser");
        return (
            <div style={{margin: "15px",}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    MaxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    padding: "25px 0"
                }}>
                    <div style={{padding: "0 30px"}}>
                        {/*<div style={{color:'#000',fontWeight:600,marginBottom:20}}>*/}
                        {/*    通知公告*/}
                        {/*</div>*/}
                        <Button type="primary" style={{marginBottom: 25}}
                                onClick={() => {
                                    this.addingNotices.showModal()
                                }}>新增通知</Button>
                        <AddingNotices ref={e => this.addingNotices = e} key={this.state.modalKey} onCloseCall={() => {
                            this.setState({modalKey: uuid()})
                        }} getList={this.getList}/>
                        <div style={{paddingBottom: 20}}>
                            <Scrollbars autoHeight autoHeightMax={height}>
                                <BaseTable rowKey="id" columns={this.state.columns} dataSource={this.state.dataSource}>
                                </BaseTable>
                            </Scrollbars>
                        </div>
                    </div>
                    <div>
                        {this.state.count > 0 ? <Pagination defaultCurrent={this.state.page}
                                                            showQuickJumper={true}
                                                            total={this.state.count}
                                                            pageSize={this.state.pageSize}
                                                            showTotal={total => `共 ${this.state.count} 条`}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-end',
                                                                padding: "15px 30px 0 30px",
                                                                borderTop: "1px solid #e8e8e8"
                                                            }}
                                                            onChange={this.onShowSizeChange}
                                                            showSizeChanger
                                                            onShowSizeChange={this.onShowSizeChange}
                        /> : null}
                    </div>

                </div>
                {/*查看详情弹窗*/}
                {this.renderViewModel()}
            {/*    查看已读弹窗*/}
                {this.renderReadMedal()}
            </div>
        )
    }

    renderReadMedal(){
        return(
            <Modal
                width={400}
                title ={'查看已读'}
                visible={this.state.readMedal}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                id={'readMedal'}
            >
                {this.renderReadTab()}
                <div style={{height: 400}}>
                    <Scrollbars autoHeight autoHeightMax={400}>
                        {this.state?.readList?.map((item, index) => {
                            return (
                                <div key={index}
                                     style={{
                                         display: 'flex',
                                         justifyContent: 'center',
                                         alignItems: 'center',
                                         padding: '5px 0px'
                                     }}>
                                    <div style={{
                                        width: '40%',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: 'rgba(0, 0, 0, 0.85)'
                                    }}
                                         title={item.userName}>
                                        {item.userName}
                                    </div>
                                    <div style={{
                                        width: '40%',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: 'rgba(0, 0, 0, 0.45)'
                                    }}
                                         title={item.deptName}>
                                        {item.deptName}
                                    </div>
                                </div>
                            )
                        })}
                    </Scrollbars>
                </div>
            </Modal>
        )
    }

    renderReadTab() {
        let {readNum, readTotal} = this.state
        let noReadTotal = readNum - readTotal
        return (
            <div id={'readTab'}>
                <Tabs activeKey={this.state.current} onChange={(e) => {
                    this.onChangeTabs(e)
                }}>
                    {/*{tablist.map((item, index) => {*/}
                    {/*    return (<TabPane tab={item.name+'(1)'} key={item.name} style={{paddingLeft: 30}}></TabPane>)*/}
                    {/*})}*/}
                    <TabPane tab={'已读'+`(${readTotal})`} key={'已读'} style={{paddingLeft: 30}}></TabPane>
                    <TabPane tab={'未读'+`(${noReadTotal})`} key={'未读'} style={{paddingLeft: 30}}></TabPane>
                </Tabs>
                <style>
                    {`#readTab .ant-tabs-top-bar .ant-tabs-nav-container .ant-tabs-nav-animated .ant-tabs-tab{width: 100px;text-align: center;}
                      #readTab .ant-tabs-top-bar .ant-tabs-nav-container .ant-tabs-nav-wrap{display: flex;justify-content: center;align-items: center;}
                      #readTab .ant-tabs-top-bar .ant-tabs-nav-container .ant-tabs-nav-wrap .ant-tabs-tab{font-size: 16px}
                      #readTab{margin-top:-20px}
                    `}
                </style>
            </div>
        )
    }

    //切换列表
    onChangeTabs(e) {
        if (e === '已读') {
            this.state.readStatus=1
        } else {
            this.state.readStatus=0
        }
        this.state.current = e;
        this.setState({}, () => {
            this.getReadList()
        })
    }
    getReadList(){
        let {noticeId,readStatus}=this.state;
        this.request({
            url: '/cm-sites-sys/notice/getNoticeStatisticsByStatus',
            method:"post",
            body:{noticeId,status:readStatus},
            // contentType: "form-data",
            callBack: (data) => {
                if(data){
                    this.setState({readList:data})
                }
            },
        });
    }

    titleHeight=0
    renderViewModel() {
        return (
            <div className={'modalHeader'}>
                <Modal
                    key={uuid()}
                    title={'通知公告详情'}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={1200}
                    footer={null}
                    bodyStyle={{padding: 0}}
                    className={"modalHeader"}
                >
                    <div style={{height: 700, display: "flex", flexDirection: "column"}}>
                        <div ref={ref=>{
                            if(typeof ref?.offsetHeight === "number" && ref.offsetHeight !== this.titleHeight) {
                                this.titleHeight = ref.offsetHeight;
                                this.setState({})
                            }
                        }}  style={{padding: '20px 40px'}}>
                            <div style={{fontSize: 20, fontWeight: 'bold'}}>{this.state.titleName}</div>
                            <div style={{borderBottom: '1px solid #cccccc', padding: '16px 0px', fontSize: 14}}>
                                <span style={{marginRight: 30}}>发布人：{this.state.senderName}</span>
                                <span style={{marginRight: 30}}>发布范围：{(() => {
                                    let text = "";
                                    switch (this.state.type) {
                                        case "all":
                                            text = "全部";
                                            break;
                                        case "users":
                                            text = "指定个人";
                                            break;
                                        case "depts":
                                            text = "指定部门";
                                            break;
                                    }
                                    return text
                                })()}</span>
                                <span
                                    style={{marginRight: 30}}>发布时间：{moment(this.state.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                                {/*<span>作者：{this.state.senderName}</span>*/}
                            </div>
                        </div>
                        <Scrollbars  style={{height: 700 - 1 - 32 - this.titleHeight - (this.state.storageFileList.length ? 200 : 0)}}>
                            <div style={{
                                padding: "0px 30px",
                                // height: this.state.storageFileList.length > 0 ? 400 : 550
                            }}> {/*w-e-text 编辑器表格*/}
                                <div className={"w-e-text"}
                                     dangerouslySetInnerHTML={{__html: filterXSS(this.state.content)}}></div>
                            </div>
                        </Scrollbars>
                        {this.state.storageFileList && this.state.storageFileList.length > 0 ? <>
                            <div style={{
                                width: '100%',
                                height: 1,
                                backgroundColor: '#cccccc',
                                margin: '16px 0px'
                            }}></div>
                            <Scrollbars style={{height:200}}>
                                <div style={{padding: '0px 40px'}}>
                                    <div style={{fontWeight: 700}}>附件
                                        <UploadWall
                                            accept={"*"}
                                            multiple={true}
                                            action="/storage/uploadFile"
                                            listType={'list'}
                                            fileList={this.state.storageFileList}
                                            icons={["download"]}
                                            showUploadBtn={false}
                                            onChange={() => {
                                            }}
                                            onRemove={() => {
                                            }}
                                            onDownload={(file) => {
                                                if (file.path.indexOf("?") === -1) {
                                                    window.location.href = file.path + "?download=1";
                                                } else {
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                        />
                                    </div>

                                </div>
                            </Scrollbars>
                        </> : ''}
                    </div>

                </Modal>
            </div>
        )
    }

    onShowSizeChange = (current, pageSize) => {
        this.state.page = current
        this.state.pageSize = pageSize
        this.getList();
    }

    //更新查看状态
    updateViewStatus(noticeId) {
        console.log(noticeId)
        this.request({
            url: '/cm-sites-sys/notice/updateNoticeStatisticsStatus',
            method: 'post',
            body: {noticeId},
            callBack: (res) => {
                console.log(res)
            }
        })
    }

    //查询附件
    getStorageFileListByUrls(attachements, call) {
        window.loading.show()
        if (!(attachements && attachements.length)) {
            call && call(attachements)
            window.loading.hide()
            return false
        }
        let array = [];
        let num = 0;
        let overFun = () => {
            num++;
            if (num === this.state.attachements.length) {
                window.loading.hide()
                call && call(this.state.storageFileList)
            }
        }
        this.state.attachements && this.state.attachements.length && this.state.attachements.forEach((item, index) => {
            this.request({
                url: '/storage/getStorageFileByUrl',
                body: {
                    url: item
                },
                contentType: "json",
                callBack: (data) => {
                    data.status = 'done';
                    data.ext = data.suffix;
                    data.url = data.path;
                    data.isChunk = true;
                    array.push(data)
                    this.state.storageFileList = array;
                    overFun()
                },
                errorCallBack: (e) => {
                    console.log(e.toString());
                    overFun()
                },
                serverVerify: {
                    serverErrorCallBack: (e) => {
                        console.log(e.toString());
                        overFun()
                    },
                    isShowErrorMsg: true
                },
            });
        })
    }

    //查询数据
    getList = () => {
        let params = {
            pageSize: this.state.pageSize,
            pageNum: this.state.page,
        }
        this.request({
            url: '/cm-sites-sys/notice/getPageList',
            method: "post",
            body: params,
            contentType: "form-data",
            callBack: (data) => {
                let dataSource = []
                let count = []
                if (data) {
                    dataSource = data.data;
                    count = data.count;
                }
                this.setState({dataSource, count})
            }
        });
    }

    //查询通知公告
    getNotice(call) {
        this.request({
            url: '/cm-sites-sys/notice/findOneById',
            body: {
                noticeId: this.state.record.id,
            },
            contentType: "form-data",
            callBack: (data) => {
                let content = "";
                let titleName = [];
                let createTime = [];
                let type = [];
                let senderName = "";
                let attachements = [];
                let noticeData = [];
                if (data) {
                    noticeData = data
                    content = data.content;
                    titleName = data.title;
                    createTime = data.createTime;
                    type = data.type;
                    senderName = data.senderName
                    attachements = data.attachements
                }
                this.setState({content, titleName, createTime, type, senderName, attachements, noticeData})
                call && call({content, titleName, createTime, type, senderName, attachements, noticeData})
            }
        });
    }

    //通知公告状态
    getUpdateStatus({params, statusNameTemp}) {
        this.request({
            url: '/cm-sites-sys/notice/updateStatus',
            method: "post",
            body: params,
            contentType: "form-data",
            callBack: (data) => {
                if (data) {
                    message.success(`${statusNameTemp || "操作"}成功`);
                } else {
                    message.error(`${statusNameTemp || "操作"}失败`);
                }
                this.getList()
            },
        });
    }

}